import { LogManager } from "@mcleod/core";
import { AutogenLayoutDistancePreferences } from "./autogen/AutogenLayoutDistancePreferences";
import { ChangeEvent } from "@mcleod/components";

const log = LogManager.getLogger("lme.powerbroker.DistancePreferences");

export class DistancePreferences extends AutogenLayoutDistancePreferences{

    override onLoad(): void {
        this.lookupModelShortAndPracticalDistance();

    }

    /** When Screen loads call the QUERY_MODEL_ENDPOINT and populate the list of distance Profile */
    private lookupModelShortAndPracticalDistance() {
        this.sourceDistanceControl.search();
        const isChecked = this.switchCreateLocalMileageRecords.checked;
        this.setLocalMileageTextboxVisibility(isChecked);
    }

    async postDataSources(): Promise<boolean> {
        try {
            if (this.mainDataSource?.hasChanged()) {
                await this.mainDataSource.post();
            }
            return true;
        } catch (error) {
            log.error(error);
            return false;
        }
    }

    switchCreateLocalMileageRecordsOnChange(event: ChangeEvent) {
        const isChecked = this.switchCreateLocalMileageRecords.checked;
        this.setLocalMileageTextboxVisibility(isChecked);
    }

    private setLocalMileageTextboxVisibility(isChecked: boolean) {
        this.textboxLocalOrderDIstance.visible = isChecked;
        this.textboxLocalMovementDistance.visible = isChecked;
        if (!isChecked) {
            this.textboxLocalOrderDIstance.text = "";
            this.textboxLocalMovementDistance.text = "";
        }
    }
}
